import React, { useState, useEffect } from 'react';
import ProgressBar from './ProgressBar';

const StatOverview = ({ stat, level, detailed, name, onUpdate }) => {
    const [baseStat, setBaseStat] = useState(stat.base);

    useEffect(() => {
        setBaseStat(stat.base);
    }, [stat.base]);

    const handleBaseStatChange = (e) => {
        const value = parseInt(e.target.value) || 0;
        setBaseStat(value);
        onUpdate(value);
        console.log('Stat updated:', { name, value }); // Debug log
    };

    return (
        <div className="flex flex-col">
            <div className="flex">
                <div>{name}</div>
                <div className="ml-auto">{stat.total}</div>
            </div>
            <div className="w-full bg-gray-200 h-1">
                <div 
                    className="bg-blue-600 h-1" 
                    style={{ width: `${(stat.total / stat.max) * 100}%` }}
                ></div>
            </div>
            <label className="text-gray-400 text-xs flex mt-0.5 items-center">
                <span>{window.charPlannerData.i18n['Base']}</span>
                <input 
                    type="number" 
                    className="ml-auto w-16 p-1 bg-gray-200" 
                    value={baseStat}
                    onChange={handleBaseStatChange}
                    min="5"
                    max={level < 40 ? 200 : level * 5}
                />
            </label>
            {detailed && (
                <>
                    <div className="text-gray-400 text-xs flex">
                        <span>{window.charPlannerData.i18n['Max']}</span>
                        <div className="ml-auto">{stat.max}</div>
                    </div>
                    <div className="text-gray-400 text-xs flex">
                        <span>{window.charPlannerData.i18n['Through items']}</span>
                        <div className="ml-auto">
                            {stat.total - stat.base} {window.charPlannerData.i18n['out of']} {stat.throughItems}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default StatOverview; 